<template>
    <div class="col-xs-12 col-sm-9 col-lg-10 pull-right presentation" v-cloak>
        <div
            :class="{
                'long-presentation': longPresentation && !showOverflow,
                'expanded-presentation': longPresentation && showOverflow
            }"
            class="presentation-text"
        >
            <slot></slot>
        </div>
        <p v-if="longPresentation && !showOverflow">...</p>
        <a href="#" v-if="longPresentation && !showOverflow" @click.prevent="toggleOverflow()">Läs mer</a>
        <a href="#" v-if="longPresentation && showOverflow" @click.prevent="toggleOverflow()">Stäng</a>
    </div>
</template>

<script>
export default {
    mounted() {
        this.checkPresentationHeight();
    },

    data: function () {
        return {
            longPresentation: false,
            showOverflow: false
        };
    },

    methods: {
        toggleOverflow: function () {
            this.showOverflow = !this.showOverflow;
        },

        checkPresentationHeight: function () {
            if ($('.presentation-text').outerHeight() > 150) {
                this.longPresentation = true;
            }
        }
    }
};
</script>
